<div class="backModal enCalendar" *ngIf="disableButtonEnter()">
  <div class="margin d-flex justify-content-center">
    <div class="lds-ring esperando">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <p class="waiting-p">{{ 'IMPRIMIENDOTICKETS' | translate }}</p>
  <!-- Agregar el texto debajo del spinner -->
</div>
<perfect-scrollbar class="cliente-fecha ps--active-y" [config]="config">
  <span *ngIf="getLocalizador() && getLocalizador() !== ''"> {{ getLocalizador() }}</span>
  <span *ngIf="getNombreCliente() && getNombreCliente() !== ''">{{ getNombreCliente() }}</span>
  <span *ngIf="getFecha() && getFecha() !== ''">{{ getFecha() }}</span>
  <ng-container
    *ngIf="
      carritoOrigen.horarios.length === 0 &&
      carrito.horarios.length === 0 &&
      router.url !== '/venta/entradas'
    "
  >
    <!-- <span>{{ paseHorarioSeleccion }}</span> -->
  </ng-container>
  <!-- Si el carrito activo ya tiene horarios, no repetir los del origen (evita recuentos duplicados al usar la «X»). -->
  <ng-container *ngIf="!(carrito?.horarios?.length > 0)">
    <span *ngFor="let sesion of carritoOrigen?.horarios || []">
      <span *ngIf="sesion.recinto">{{ sesion.resumen }}</span>
    </span>
  </ng-container>
  <div *ngIf="!carrito.reservaAgrupada">
    <span *ngFor="let sesion of carrito.horarios">
      <span *ngIf="sesion.recinto">{{ sesion.resumen }}</span>
    </span>
  </div>
</perfect-scrollbar>
<fieldset>
  <div class="white-box">
    <div class="Rtable">
      <div class="Rtable-row Rtable-row--head">
        <div class="Rtable-row-inner">
          <div class="Rtable-cell item-cell column-heading">
            {{ 'OBJETO' | translate }}
          </div>
          <div class="Rtable-cell cantidad-cell column-heading">
            {{ 'CANT' | translate }}
          </div>
          <div class="Rtable-cell precio-cell column-heading">
            {{ 'TOTAL' | translate }}
          </div>
          <div class="Rtable-cell delete-cell column-heading"></div>
        </div>
      </div>
      <perfect-scrollbar class="detailScroll ps--active-y">
        <!-- Reserva agrupada: solo este bloque. Venta normal usa el *ngFor de carrito.entradas más abajo (evita duplicar filas cuando verCarrito() devuelve las mismas entradas). -->
        <div *ngIf="carritoOrigen && carrito?.reservaAgrupada == '1'">
          <div class="Rtable-row" *ngFor="let linea of verCarrito()">
            <div class="Rtable-row-inner">
              <div
                class="Rtable-cell item-cell"
                (click)="clickToOpenMotivosModal(linea.entrada)"
              >
                <div class="Rtable-cell--content item-content">
                  {{ linea.entrada.NombrePantalla }}
                  <span
                    *ngIf="
                      linea.entrada.noEditable !== undefined &&
                      linea.entrada.noEditable !== null &&
                      linea.entrada.noEditable !== false
                    "
                    >{{ 'LOCALIZADOR' | translateV2 }}</span
                  >
                </div>
              </div>
              <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                <div class="Rtable-cell--content cantidad-content">
                  <div class="quantity">
                    <input
                      [disabled]="
                        this.ventanaActualDePago ||
                        linea.entrada.noEditable ||
                        linea.entrada.auditor + io ||
                        carritoOrigen.reservaPagada == '1' ||
                        carritoOrigen.reservaAgrupada == '1'
                      "
                      id="linea-{{ masEntradas }}{{ linea.entrada.idTarifa }}"
                      type="number"
                      class="qty text"
                      step="1"
                      min="0"
                      name="quantity"
                      category="CANTIDAD"
                      value="{{ linea.cantidad }}"
                      title="Cantidad"
                      (keydown)="inputDeTeclado($event, linea.entrada)"
                      (focus)="focusValue($event, linea.entrada)"
                      (blur)="test($event, linea.entrada)"
                      size="4"
                    />
                  </div>
                </div>
              </div>
              <div class="Rtable-cell precio-cell">
                <!-- <div class="Rtable-cell--content precio-content">
                  {{
                    conversor(linea.entrada.PrecioEnDivisaReferencia) *
                      linea.cantidad
                      | myCurrency
                        : divisaSimboloDecimal
                        : divisaDecimales
                        : divisaPosicion
                        : divisaSimbolo
                        : divisaSimboloDerecha
                        : divisaSimbSeparacionMiles
                  }}
                </div> -->
                <div class="Rtable-cell--content precio-content">
                  {{
                    getPriceByLinea(getPrecioConComision(linea.entrada).toString(), linea.cantidad)
                      | myCurrency
                        : divisaSimboloDecimal
                        : divisaDecimales
                        : divisaPosicion
                        : divisaSimbolo
                        : divisaSimboloDerecha
                        : divisaSimbSeparacionMiles
                  }}
                </div>
              </div>
              <div *ngIf="ventanaActualDePago">
                <div style="width: 40px"></div>
              </div>
            </div>
            <div
              *ngIf="
                getMotivosByEntradaId(linea.entrada.idTarifa) | async as motivos
              "
              class="resumenDescuentos"
            >
              <span *ngFor="let m of motivos"
                >* {{ m.nombre }} ({{ m.qty }})</span
              >
            </div>
            <div
              *ngIf="
                linea.entrada.CaracteristicasEntrada &&
                linea.entrada.CaracteristicasEntrada.length > 0
              "
              class="resumenDescuentos"
            >
              <span
                *ngFor="
                  let c of agruparCaracteristicas(
                    linea.entrada.CaracteristicasEntrada
                  )
                "
                >* {{ c.Tipo }} {{ c.Rango }} {{ c.Nivel }}</span
              >
            </div>
            <div *ngIf="linea.entrada['extraData'] && !linea.entrada['BarCode']" class="resumenDescuentos">
              <span
                >*
                {{
                  linea.entrada.extraData.espectaculo.chNombreEspectaculo || ''
                }}</span
              >
              <span
                >* Recinto :{{
                  linea.entrada.extraData.info.infoGeneral.nombreRecinto || ''
                }}</span
              >
              <span *ngIf="linea.entrada.extraData.tag !== ''"
                >* Fila: {{ linea.entrada.extraData.dataNumFila }} Butaca:
                {{ linea.entrada.extraData.dataNumButaca }}
              </span>
              <span>* {{ getFechaHora(linea.entrada) }} </span>
            </div>
            <div
              *ngIf="linea.entrada['PromocionEntradas']"
              class="resumenDescuentos"
            >
              <span *ngFor="let promocion of linea.entrada['PromocionEntradas']"
                >* {{ promocion.NombreTipo }} ({{
                  linea.cantidad * promocion.NumeroEntradas
                }})</span
              >
            </div>
          </div>
        </div>
        <div *ngIf="carrito && carrito.reservaAgrupada !== '1'">
          <div class="Rtable-row" *ngFor="let linea of carrito.entradas">
            <div class="Rtable-row-inner">
              <div
                class="Rtable-cell item-cell"
                (click)="clickToOpenMotivosModal(linea.entrada)"
              >
                <div class="Rtable-cell--content item-content">
                  {{ linea.entrada.NombrePantalla }}
                  <span
                    *ngIf="
                      linea.entrada.noEditable !== undefined &&
                      linea.entrada.noEditable !== null &&
                      linea.entrada.noEditable !== false
                    "
                    >({{ 'LOCALIZADOR' | translateV2 }})</span
                  >
                </div>
              </div>
              <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                <div class="Rtable-cell--content cantidad-content">
                  <div class="quantity">
                    <input
                      [disabled]="
                        this.ventanaActualDePago ||
                        linea.entrada.noEditable ||
                        linea.entrada.auditorio ||
                        linea.entrada.desdeAsociado
                      "
                      id="linea-{{ masEntradas }}{{ linea.entrada.idTarifa }}"
                      type="number"
                      class="qty text"
                      step="1"
                      min="0"
                      name="quantity"
                      category="CANTIDAD"
                      value="{{ linea.cantidad }}"
                      title="Cantidad"
                      (keydown)="inputDeTeclado($event, linea.entrada)"
                      (focus)="focusValue($event, linea.entrada)"
                      (blur)="test($event, linea.entrada)"
                      size="4"
                    />
                  </div>
                </div>
              </div>
              <div class="Rtable-cell precio-cell">
                <!-- <div class="Rtable-cell--content precio-content">
                  {{
                    conversor(linea.entrada.PrecioEnDivisaReferencia) *
                      linea.cantidad
                      | myCurrency
                        : divisaSimboloDecimal
                        : divisaDecimales
                        : divisaPosicion
                        : divisaSimbolo
                        : divisaSimboloDerecha
                        : divisaSimbSeparacionMiles
                  }}
                </div> -->
                <div class="Rtable-cell--content precio-content">
                  {{
                    getPriceByLinea(getPrecioConComision(linea.entrada).toString(), linea.cantidad)
                      | myCurrency
                        : divisaSimboloDecimal
                        : divisaDecimales
                        : divisaPosicion
                        : divisaSimbolo
                        : divisaSimboloDerecha
                        : divisaSimbSeparacionMiles
                  }}
                </div>
              </div>
              <div class="Rtable-cell delete-cell" *ngIf="!ventanaActualDePago">
                <div class="Rtable-cell--content delete-content">
                  <!-- mousedown preventDefault evita que el input CANTIDAD pierda foco → blur → losefocus → sendEntradas(0) antes del click (saltos tipo 3→1). -->
                  <a
                    href="#"
                    (mousedown)="$event.preventDefault()"
                    (click)="$event.preventDefault(); eliminarLinea(linea)"
                    title="Borrar"
                  >
                    <span class="cross"></span>
                    <span class="sr-only">cerrar</span>
                  </a>
                </div>
              </div>
              <div *ngIf="ventanaActualDePago">
                <div style="width: 40px"></div>
              </div>
            </div>
            <div
              *ngIf="
                getMotivosByEntradaId(linea.entrada.idTarifa) | async as motivos
              "
              class="resumenDescuentos"
            >
              <span *ngFor="let m of motivos"
                >* {{ m.nombre }} ({{ m.qty }})</span
              >
            </div>
            <div
              *ngIf="
                linea.entrada.CaracteristicasEntrada &&
                linea.entrada.CaracteristicasEntrada.length > 0
              "
              class="resumenDescuentos"
            >
            <ng-container
              *ngFor="let c of agruparCaracteristicas(linea.entrada.CaracteristicasEntrada)">
              <span *ngIf="c.Tipo || c.Rango || c.Nivel">
                * {{ c.Tipo }} {{ c.Rango }} {{ c.Nivel }}
              </span>
            </ng-container>
            </div>
            <div *ngIf="linea.entrada['extraData'] && !linea.entrada['BarCode']" class="resumenDescuentos">
              <span
                >*
                {{
                  linea.entrada.extraData.espectaculo.chNombreEspectaculo || ''
                }}</span
              >
              <span
                >* {{ 'RECINTO' | translateV2 }} :{{
                  linea.entrada.extraData.info.infoGeneral.nombreRecinto || ''
                }}</span
              >
              <span *ngIf="linea.entrada.extraData.tag !== ''"
                >* {{ 'FILA' | translateV2 }}:
                {{ linea.entrada.extraData.dataNumFila }}
                {{ 'BUTACA' | translateV2 }}:
                {{ linea.entrada.extraData.dataNumButaca }}
              </span>
              <span>* {{ getFechaHora(linea.entrada) }} </span>
            </div>
            <div
              *ngIf="linea.entrada['PromocionEntradas']"
              class="resumenDescuentos"
            >
              <span *ngFor="let promocion of linea.entrada['PromocionEntradas']"
                >* {{ promocion.NombreTipo }} ({{
                  linea.cantidad * promocion.NumeroEntradas
                }})</span
              >
            </div>
          </div>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</fieldset>
<div class="NumpadWrap">
  <div class="totales" *ngIf="!hayDescuento">
    <div class="titulos">
      <span>{{ 'CANTIDAD' | translate }}</span>
      <span>{{ 'TOTAL' | translate }}</span>
    </div>
    <div class="numeros" *ngIf="carrito">
      <span>{{ carrito.cantidadTotal }}</span>
      <span>{{
        getPrecioTotalConComision()
          | myCurrency
            : divisaSimboloDecimal
            : divisaDecimales
            : divisaPosicion
            : divisaSimbolo
            : divisaSimboloDerecha
            : divisaSimbSeparacionMiles
      }}</span>
    </div>
  </div>
  <div class="totales" *ngIf="hayDescuento">
    <div class="titulos">
      <span>{{ 'CANTIDAD' | translate }}</span>
      <span>{{ 'TOTAL' | translate }}</span>
    </div>
    <div class="numeros" *ngIf="carrito">
      <span>{{ carrito.cantidadTotal }}</span>
      <span>{{
        carrito.precioTotalSinDescuento
          | myCurrency
            : divisaSimboloDecimal
            : divisaDecimales
            : divisaPosicion
            : divisaSimbolo
            : divisaSimboloDerecha
            : divisaSimbSeparacionMiles
      }}</span>
    </div>
    <div class="descuentos">
      <span class="titulo">{{ 'TOTALDESCUENTO' | translate }}</span>
      <span>{{
        carrito.importeDescuento
          | myCurrency
            : divisaSimboloDecimal
            : divisaDecimales
            : divisaPosicion
            : divisaSimbolo
            : divisaSimboloDerecha
            : divisaSimbSeparacionMiles
      }}</span>
    </div>
    <div class="descuentos">
      <span class="titulo">{{ 'TOTALCONDESCUENTO' | translate }}</span>
      <span class="numeros">{{
        carrito.precioTotal
          | myCurrency
            : divisaSimboloDecimal
            : divisaDecimales
            : divisaPosicion
            : divisaSimbolo
            : divisaSimboloDerecha
            : divisaSimbSeparacionMiles
      }}</span>
    </div>
  </div>
  <ticketing-numpad *ngIf="router.url !== '/amigos-thyssen'"></ticketing-numpad>
  <button
    *ngIf="showSalePauseButton()"
    [disabled]="disabledSalePause()"
    (click)="pausar()"
    type="button"
    class="pagar"
  >
    {{ 'PAUSAR' | translateV2 }}
  </button>
  <button
    *ngIf="!checkIfModalOpen()"
    [disabled]="sePuedeFinalizar()"
    (click)="pagar()"
    type="button"
    value="PAGAR"
    class="pagar"
  >
    {{ mostrarFinalizarPagar() | translate }}
  </button>
  <button
    *ngIf="checkIfModalOpen()"
    (click)="closeModal()"
    type="button"
    value="PAGAR"
    class="pagar"
  >
    {{ 'ACEPTAR' | translateV2 }}
  </button>
</div>
